export class VariablesArray {
    public static variables = [
        "%vorname%",
        "%nachname%",
        "%geburtsname%",
        "%strasse%",
        "%hausnummer%",
        "%plz%",
        "%ort%",
        "%land%",
        "%geburtsland%",
        "%geburtsdatum%",
        "%nationalitaet%",
        "%email%",
        "%telefon%",
        "%mobil%",
        "%current_date%",
    ]
}